<div class="container-1">
  <div class="control-row group-select">
    <span>Группа: </span>
    <select class="inp-1 group-select" type="text" [(ngModel)]="model.snippetGroupVal" (change)="snippetGroupChange()">
      <option value="0">Не задана</option>
      @for (g of model.snippetsGroups; track g) {
        <option [value]="g.id">{{g.txtValue}}</option>
      }
    </select>
  </div>
  <div class="control-row">
    <button class="btn-1" (click)="newSnippetClick()">{{text.of('Add snippet')}}</button>
    <input class="search" type="text"
      [(ngModel)]="model.snippetSearchVal"
      (keyup)="searchKeyUp()"
      onclick="this.select()"
      [placeholder]="text.of('placeholder Search')" />
      <button class="btn-1" (click)="searchSnippetsClick()">Показать</button>

    </div>

    @if ([ItemStates.Create, ItemStates.Edit].includes(model.snippetState)) {
      <div class="new-item">
        @if (model.snippetState==ItemStates.Create) {
          <b>Новый сниппет</b>
        }
        @if (model.snippetState==ItemStates.Edit) {
          <b>Редактирование сниппета</b>
        }
        <div class="code">
          <div
            class="ace-editor-wrapper"
            #editor>
          </div>
        </div>
        <div class="description">
          <textarea [(ngModel)]="model.snippetEditItem.description" type="text" rows="3"
          [placeholder]="text.of('placeholder Description')"></textarea>
          <div>
            <select [(ngModel)]="model.snippetEditItem.mode" (change)="editItemModeChange()">
              @for (it of Constants.aceModes; track it) {
                <option [value]="it">{{it}}</option>
              }
            </select>
          </div>
        </div>
        <div class="control-row">
          <button class="btn-1" (click)="snippetSave()">{{text.of('newSnippetSave Save snippet')}}</button>
          <button class="btn-1" (click)="snippetSaveCancel()">{{text.of('newSnippetSaveCancel Close')}}</button>
        </div>
      </div>
    }
  </div>

  <div class="result-content-container">
    @for (s of model.snippetSearchResult; track s) {
      <div>
        <div class="row-1">
          @if (s.Description) {
            <span class="description">{{s.Description}}</span>
          }
          @if (s.GroupName) {
            <span class="group-name">({{s.GroupName}})</span>
          }
          <button class="btn-1" (click)="snippetCopyClick(s)">{{text.of('Copy')}}</button>
          <button class="btn-1" (click)="snippetToRelacing(s)">TO REPLACING</button>
          <button class="btn-1" (click)="snippetEditClick(s)">ИЗМЕНИТЬ</button>
          @if (!s.Deleted) {
            <button class="btn-1 delete" (click)="snippetDelete(s)">{{text.of('Delete')}}</button>
          }
          @if (s.Deleted) {
            <span class="deleted">{{text.of('Deleted')}}</span>
          }
        </div>
        <div [innerHTML]="s.TxtValueHtml | safeHtml" [class]="'code '+s.Mode"></div>
        <!-- <div class="buttons">
      </div> -->
    </div>
  }
</div>

